import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex)

const state = {
    windowHeight: 0,           //窗口高度
    windowWidth: 0,            //窗口宽度
}
const getters = {};
const mutations = {
    updateWindowHeight (state, val) {
        state.windowHeight = val;
    },
    updateWindowWidth (state, val) {
        state.windowWidth = val;
    }
}
const actions = {}

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions
})



// WEBPACK FOOTER //
// ./src/store/index.js